import FormJaivana from "dashboard_jaivana_v1";
/**
 * @description: CustomReconstruirCosto
 * @author: Patricia Lopez Sanchez
 * @version: jdesk_1.01.0003
 **/
class CustomReconstruirCosto extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                                               = this.initForm.bind(this);
        this.ver_historia                                           = this.ver_historia.bind(this);
        this.successVerHistoria                                     = this.successVerHistoria.bind(this);
        this.gridOptionsComponentes                                 = Object.assign({}, this.gridOptions);
        this.formatNumberSaldo                                      = this.formatNumberSaldo.bind(this);
        this.currencyFormatterGeneral                               = this.currencyFormatterGeneral.bind(this);
        this.validar                                                = this.validar.bind(this);
        this.successValidar                                         = this.successValidar.bind(this);
        this.procesar                                               = this.procesar.bind(this);
        this.successProcesar                                        = this.successProcesar.bind(this);
        this.procesartodos                                          = this.procesartodos.bind(this);
        this.successProcesartodos                                   = this.successProcesartodos.bind(this);
        this.limpiar                                                = this.limpiar.bind(this);
        this.validarfechasConsulta                                  = this.validarfechasConsulta.bind(this);
        this.traerPropiedades                                       = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades                                 = this.sucesstraerPropiedades.bind(this);
        this.fecha_hoy                                              = '';
        this.dias_maximo                                            = 0;

    }

    initForm() {
        console.log("Formulario CustomReconstruirCosto,  @version: jdesk_1.01.0003, @author: Patricia Lopez Sanchez");
        this.codigo_usuario = JSON.parse(localStorage.getItem('res')).codigo;
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;

        this.traerPropiedades();
        this.getField("desde").setOnChange(this.limpiar);
        this.getField("nombre_articulo").setOnChange(this.limpiar);
        this.getField("ver_historia").setClick(this.ver_historia);
        this.getField("ok").setClick(this.validar);
        this.getField("procesar").setClick(this.procesar);
        this.getField("procesar_todos").setClick(this.procesartodos);

        let hoy= new Date();
        let dia=hoy.getDate();
        let mes=hoy.getMonth()+1;
        let año=hoy.getFullYear();
        if(mes<10){
            mes='0'+mes;
        }
        if(dia<10){
            dia='0'+dia;
        }
        this.fecha_hoy=año+'-'+mes+'-'+dia;
    }

    limpiar(){
        this.getField("ver_historia").setDisabled(false);
        this.gridOptionsComponentes['rowData'] = [];            
        let configCell = new Map();
        this.getField('rejilla').initData(this.gridOptionsComponentes,configCell);
        this.getField('rejilla').toggle(false)
    }

    traerPropiedades(){
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso
        }};
        this.generalFormatPmv = { tipo_servicio: 'inve-reconstruircosto', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
        
    }
    
    sucesstraerPropiedades(data){
        if(data.estado_p === 200){  
            this.dias_maximo=data.data.recalcular_costo_dias_devolver;

        }else if(data.estado_p === 404){
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    ver_historia(){
        if(this.getField('codigo_articulo').valid() && this.getField('nombre_articulo').valid() && this.getField('bodega').valid() && 
        this.getField('nombre_bodega').valid()){
            let datos={ datos: {
                bodega: this.getField("bodega").getValue(),
                codigo_articulo: this.getField("codigo_articulo").getValue(),
                desde: this.getField("desde").getValue()
            }};
            this.generalFormatPmv = { tipo_servicio: 'inve-reconstruircosto', operacion: 'verhistoria', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successVerHistoria,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }
    }

    successVerHistoria(data){
        if (data.estado_p === 200 )
        {
            this.getField('ver_historia').setDisabled(true);
            this.getField('rejilla').toggle(true);
            let configCell = new Map();
            this.gridOptionsComponentes['rowData'] = data.data;
            configCell.set('saldo_antes', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo_antes) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('costopro_antes', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costopro_antes) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('costopro_despues', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costopro_despues) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo_despues', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo_despues) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cantidad', { cellRenderer: function (props) { return props.data.cantidad}, cellStyle: { textAlign: "right"}, field: 'cantidad' });
            configCell.set('costo_unitario', { cellRenderer: function (props) { return props.data.costo_unitario}, cellStyle: { textAlign: "right"}});
            this.getField('rejilla').initData(this.gridOptionsComponentes, configCell);
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
            }
        }
    }

    validar(){
        if(this.getField('articulos').valid() ){
            let datos={ datos: {
                articulos: this.getField("articulos").getValue()
            }};
            this.generalFormatPmv = { tipo_servicio: 'inve-reconstruircosto', operacion: 'validar', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successValidar,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }
    }

    successValidar(data){
        if (data.estado_p === 200 )
        {
            this.getField('codigos_error').setValue(data.data.codigo_errores);
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
            }
        }
    }

    procesar(){
        if( this.getField('bodega').valid() && this.getField('nombre_bodega').valid() && this.getField('articulos').valid() ){
            let datos={ datos: {
                articulos: this.getField("articulos").getValue(),
                bodega: this.getField("bodega").getValue(),
                desde: this.getField("desde").getValue()
            }};
            this.generalFormatPmv = { tipo_servicio: 'inve-reconstruircosto', operacion: 'procesar', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successProcesar,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }
    }

    successProcesar(data){
        if (data.estado_p === 200 )
        {
            this.alertGeneral.toggle(true, 'Termino el proceso.', 'success');
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
            }
        }
    }

    procesartodos(){
        this.getField('desde').setError(false,'');
        let errores=0;
        if(this.validarfechasConsulta()===false)
            errores++;
        
        if (errores===0) {
            this.mostrarMensajeGenerando();
            let datos={ datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                desde: this.getField("desde").getValue()
            }};
            this.generalFormatPmv = { tipo_servicio: 'inve-reconstruircosto', operacion: 'procesar_todo', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successProcesartodos,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }
    }   

    validarfechasConsulta(){

        this.getField("desde").setError(false,"");
        let fecha_actual =new Date().toISOString().split('T')[0];
        let consultar_desde = new Date(this.getField("desde").getValue()).toISOString().split('T')[0];
        if(consultar_desde > fecha_actual){
            this.getField("desde").setError(true,"No puede ser mayor a la fecha actual.");
            return false;
        }

        let fecha=new Date(fecha_actual);
        fecha.setDate(fecha.getDate()-this.dias_maximo);
        console.log(this.dias_maximo)
        fecha=fecha.toISOString().split('T')[0];
        if(consultar_desde < fecha){
            this.getField("desde").setError(true,"No es posible devolverse más de "+this.dias_maximo+" días.");
            return false;
        }

        let diferencia=new Date(fecha).getTime()-new Date(consultar_desde).getTime();
        diferencia = diferencia / 1000 / 60 / 60 / 24;
        if(diferencia >this.dias_maximo){
            this.getField("desde").setError(true,"No es posible devolverse más de "+this.dias_maximo+" días.");
            return false;
        }
    
        return true;
    }

    successProcesartodos(data){
        if (data.estado_p === 200 )
        {
            this.getField('confirmModalCustom').toggle(false);
            this.alertGeneral.toggle(true, 'Termino el proceso.', 'success');
        }else {
            this.getField('confirmModalCustom').toggle(false);
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
            }
        }
    }

    currencyFormatterGeneral(number)
    {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
          if ((decimal !== 0) && (decimal !== undefined)) {
            if(decimal.length>2){
              decimal=(Number(number).toFixed(2) + "").split(".")[1];
            }
          return (this.formatNumberSaldo(number) + "," + decimal);
          } else {
          return this.formatNumberSaldo(number); }
    }

    formatNumberSaldo(number)
    {
            return Number(number).toString().split('.')[0]
             .toString()
             .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

    mostrarMensajeNoHayDatos(){
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }
}
FormJaivana.addController("inve-reconstruircosto", CustomReconstruirCosto);
export default CustomReconstruirCosto;